@let _isDialogDisplayed = isDialogDisplayed();
<cv-dialog
  [visible]="_isDialogDisplayed"
  (visibleChange)="onDialogVisibilityChange($event)"
  [style]="{ 'max-width': '960px' }"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [blockScroll]="true"
  (hide)="onDialogHiding()"
>
  <ng-template #header>
    <div class="mission__title">
      <h2 class="prose prose-2xl! font-bold text-slate-600 dark:text-slate-100">{{ clientMission }}</h2>
      <span class="mission__title__timelapse">{{ timelapseMission }}</span>
    </div>
  </ng-template>
  <ng-template #content>
    <div [class.mission__content--transition]="!isLoading" class="mission__content flex grow">
      @if (isLoading) {
        <div class="flex grow justify-center">
          <cv-spinner></cv-spinner>
        </div>
      } @else {
        <div class="mission__content__text">
          <markdown [data]="innerLightMission"></markdown>
          <markdown [data]="innerFullMission" class="flex flex-col gap-3"></markdown>
        </div>
      }
    </div>
  </ng-template>
</cv-dialog>
